var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.37,
    height: 59.37,
    viewBox: "0 0 59.37 59.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2003",
    "data-name": "Group 2003",
    transform: "translate(-1179.693 -409.957)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 29.685,
    cy: 29.685,
    rx: 29.685,
    ry: 29.685,
    transform: "translate(1179.693 409.957)",
    fill: "#747474",
    opacity: 0.106
  }), /*#__PURE__*/React.createElement("path", {
    id: "chart-simple",
    d: "M14.949,29.9a3.748,3.748,0,0,1-3.737-3.737V3.737a3.737,3.737,0,0,1,7.475,0V26.161A3.748,3.748,0,0,1,14.949,29.9Zm11.212,0a3.748,3.748,0,0,1-3.737-3.737V11.212a3.737,3.737,0,0,1,7.475,0V26.161A3.748,3.748,0,0,1,26.161,29.9Zm-22.424,0A3.748,3.748,0,0,1,0,26.161V18.687a3.737,3.737,0,0,1,7.475,0v7.475A3.748,3.748,0,0,1,3.737,29.9Z",
    transform: "translate(1193.655 424.693)",
    opacity: 0.995
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/paid.6e5e8ff650ad019d77196a5bc0a29def.svg";
export { ForwardRef as ReactComponent };